import api from '@pray/shared/utils/api';

import type { UpdateExperimentParams } from './types/app';

/**
 * Updates an experiment active or archived status
 * @param instanceName - The instance name
 * @param experimentId - The experiment id
 * @param active - The active status
 * @param archived - The archived status
 */
export async function updateExperiment({ instanceName, experimentId, active, archived }: UpdateExperimentParams) {
  if (!instanceName) throw new Error('Instance Name is required');
  if (!experimentId) throw new Error('Experiment ID is required');
  if (active === undefined && archived === undefined) {
    throw new Error('At least one of active or archived must be provided');
  }

  const params = {
    instance_name: instanceName,
  };

  const body = {
    active,
    archived,
  };

  const url = `/web/studio/experiments/${experimentId}`;

  await api.executePutRequest<void>(url, body, { params });
}
